import React from "react";
import { MdOutlineMailOutline } from "react-icons/md";
import { IoMdLocate } from "react-icons/io";
import { FaPhoneVolume,FaTwitter,FaFacebook,FaYoutube } from "react-icons/fa";



const ContactUs = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen p-6 flex flex-col gap-6">
      {/* First Div: Contact Information */}
      <div className="bg-gray-800 p-6 rounded-lg shadow-md grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="bg-slate-950 flex flex-col justify-center items-center p-8 rounded-tr-3xl rounded-bl-3xl">
             <MdOutlineMailOutline className="text-red-800 text-5xl"/>
             <p>Email</p>
             <p className="">energygrim93@gmail.com</p>
        </div>
       <div className="bg-slate-950 flex flex-col justify-center items-center p-8 rounded-tr-3xl rounded-bl-3xl">
        <IoMdLocate className="text-red-800 text-5xl"/>
        <p>Address</p>
        <p> 123 Main Street, City, Country</p>
       </div>
        <div className="bg-slate-950 flex flex-col justify-center items-center p-8 rounded-tr-3xl rounded-bl-3xl">
          <FaPhoneVolume className="text-red-800 text-5xl"/>
          <p>Phone</p>
          <p> +91 8708274819</p>
        </div>
        
      </div>

      {/* Second Div: Contact Form */}
      <div className="bg-gray-700 p-6 rounded-lg shadow-md grid grid-cols-1 lg:grid-cols-2">
        <div>
          <div><h2 className="text-2xl font-bold mb-4">Contact Us</h2></div>
          <div><p>Have a question? Drop us a message, and let’s discuss. Let’s keep the party going because, with Grim, the fun never stops!</p></div>
          <div className="flex lg:flex-row justify-center items-center gap-6 m-12">
             <FaFacebook className="text-6xl bg-red-800 p-2 rounded-full"/>
             <FaTwitter className="text-6xl bg-red-800 p-2 rounded-full"/>
             <FaYoutube className="text-6xl bg-red-800 p-2 rounded-full"/>
          </div>
        </div>
        
        <form className="flex flex-col gap-4">
          <input type="text" placeholder="Name" className="p-2 bg-gray-800 text-white border border-gray-600 rounded" required />
          <input type="email" placeholder="Email" className="p-2 bg-gray-800 text-white border border-gray-600 rounded" required />
           <input type="email" placeholder="Mobile No." className="p-2 bg-gray-800 text-white border border-gray-600 rounded" required />
            <input type="email" placeholder="Subject" className="p-2 bg-gray-800 text-white border border-gray-600 rounded" required />
          <textarea placeholder="Message" className="p-2 bg-gray-800 text-white border border-gray-600 rounded" required></textarea>
          <button type="submit" className="bg-red-600 text-white font-bold py-2 px-4  hover:bg-red-800 rounded-3xl">Send</button>
        </form>
      </div>

      {/* Third Div: Location */}
      <div className="bg-gray-800 p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-4">Our Location</h2>
        <p>Find us here:</p>
        <iframe 
          className="w-full h-64 rounded-lg" 
          src="https://www.google.com/maps/embed?pb=!1m18..."
          allowFullScreen 
          loading="lazy"
          title="address location"
          >
        </iframe>
      </div>
    </div>
  );
};

export default ContactUs;